module.exports = __webpack_public_path__ + "img/mexican.5a12d396.jpeg";